import { Pipe, PipeTransform } from "@angular/core";
import { get } from "lodash";

import { STRING } from "../constants/string";

@Pipe({
  name: "getField",
})
export class GetFieldPipe implements PipeTransform {
  transform(path: string, data: Record<string, any>, defaultValue: any = STRING.EMPTY): any {
    return get(data, path) || defaultValue;
  }
}
